export default __webpack_public_path__ + "4071b8e1a77c3ac3199759723eda4c2e.jpg";